import { render } from "./SessionPickerSkeletonV2.vue?vue&type=template&id=a47f7f56"
import script from "./SessionPickerSkeletonV2.vue?vue&type=script&lang=js"
export * from "./SessionPickerSkeletonV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__